var exports = {
  "Qs": "x127c5a35--6271aa--content",
  "DD": "x127c5a35--6271aa--title",
  "Tp": "x127c5a35--6271aa--background",
};

module.exports = exports;
